import { render, staticRenderFns } from "./CommonQues.vue?vue&type=template&id=d6ab54a4&scoped=true"
import script from "./CommonQues.vue?vue&type=script&lang=js"
export * from "./CommonQues.vue?vue&type=script&lang=js"
import style0 from "./CommonQues.vue?vue&type=style&index=0&id=d6ab54a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ab54a4",
  null
  
)

export default component.exports